import { useTranslation } from "react-i18next"

import { Skeleton } from "@/components/ui/skeleton"

/**
 * OKS-519 — §13 loading skeleton (Figma `55:2229`).
 *
 * Podium skeleton (3 circular shimmer avatars + name/XP bars) + 3 row
 * skeletons matching the 2-line layout — NOT a spinner. Rendered while a
 * full Inertia visit to this surface is in flight (e.g. a brand switch).
 */
export function LeaderboardSkeleton() {
  const { t } = useTranslation()

  return (
    <div
      data-testid="creator-leaderboard-skeleton"
      role="status"
      aria-label={t("leaderboard.creator.loading_aria")}
      className="flex flex-col gap-6"
    >
      <Skeleton className="h-6 w-40 rounded-full" />

      <div className="flex items-end justify-center gap-4 pt-2">
        {[44, 56, 44].map((size, i) => (
          <div key={i} className="flex flex-col items-center gap-2">
            <Skeleton
              className="rounded-full"
              style={{ width: size, height: size }}
            />
            <Skeleton className="h-3 w-14" />
            <Skeleton className="h-3 w-10" />
          </div>
        ))}
      </div>

      <div className="flex flex-col gap-2">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="flex items-center gap-3 px-3 py-2.5">
            <Skeleton className="h-4 w-6" />
            <Skeleton className="size-11 rounded-full" />
            <div className="flex flex-1 flex-col gap-1.5">
              <Skeleton className="h-3.5 w-28" />
              <Skeleton className="h-3 w-20" />
            </div>
            <Skeleton className="h-4 w-12" />
          </div>
        ))}
      </div>
    </div>
  )
}
